import React, { useState, useRef, useEffect } from 'react';
import './CustomDropdown.scss';

interface Item {
  key: string;
  label: string;
}

interface Props {
  items: Item[];
  selectedKey: string;
  onChange: (key: string) => void;
  placeholder?: string;
}

const CustomDropdown: React.FC<Props> = ({
  items,
  selectedKey,
  onChange,
  placeholder = 'Izaberi…',
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  // Zatvori dropdown kad se klikne van njega
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const selectedItem = items.find(item => item.key === selectedKey);

  const handleSelect = (key: string) => {
    onChange(key);
    setOpen(false);
  };

  return (
    <div className="custom-dropdown" ref={ref}>
      <div
        className="dropdown-header"
        onClick={() => setOpen(prev => !prev)}
      >
        {selectedItem?.label ?? placeholder}
        <span className={`arrow ${open ? 'up' : 'down'}`} />
      </div>

      {open && (
        <ul className="dropdown-list">
          {items.map(item => (
            <li
              key={item.key}
              className={`dropdown-item ${item.key === selectedKey ? 'active' : ''}`}
              onClick={() => handleSelect(item.key)}
            >
              {item.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdown;